import * as api from '../api';
import { shipmentTrackingDetailRequest } from '../api/requestCreator';

export const GET_SHIPMENT_TRACKING_DETAIL_FETCHING =
  '[trackingDetails] Get Shipment Tracking Details Fetching';
export const HANDLE_SHIPMENT_TRACKING_RESPONSE =
  '[trackingDetails] Handle Shipment Tracking Details';

export const getShipmentTrackingDetailFetching = (trackingNumber: String) => ({
  type: GET_SHIPMENT_TRACKING_DETAIL_FETCHING,
  meta: { trackingNumber },
});
export const handleShipmentTrackingResponse = (
  trackingNumber: String,
  response: Object
) => ({
  type: HANDLE_SHIPMENT_TRACKING_RESPONSE,
  meta: { trackingNumber },
  payload: response,
});

export const getShipmentTrackingDetail = (
  providerCode: string,
  trackingNumber: String,
  orderNumber: String,
) => (dispatch: Function) => {
  dispatch(getShipmentTrackingDetailFetching(trackingNumber));
  api
    .getRequest(shipmentTrackingDetailRequest(providerCode, trackingNumber, orderNumber))
    .then(
      (response: Object) => {
        dispatch(handleShipmentTrackingResponse(trackingNumber, response));
      },
      (error: Object) => {
        console.log(error);
        dispatch(
          handleShipmentTrackingResponse(trackingNumber, error.response)
        );
      }
    );
};
